import { Injectable } from '@angular/core';
import { ApiService } from '@uranda/commons';
import { HttpParams } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ReviewVerifyService extends ApiService {

    async verifyReview(token: string): Promise<any> {
        const params = new HttpParams().set('token', token);
        const response = await lastValueFrom(
            this.httpClient.get<any>(`${this.getApiUrl()}/v1/review/verify`, { params })
        );
        return response.data;
    }
}

